module.exports = __webpack_public_path__ + "img/ImageQresult1.7283b337.png";